import React from 'react';
import { useTranslation } from '../../TranslationContext';
import { motion } from 'framer-motion';

function LanguageBanner() {
	const { t, language, setLanguage, translationButtons } = useTranslation();
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.5, ease: "easeInOut" }}
			className="LanguageBanner"
		>
			{translationButtons.map(div => (
				<motion.div
					whileHover={{
						scale: 1.1,
						transition: { duration: 0.1 },
					}}
					whileTap={{ scale: 0.9 }}
					className={`LanguageIcon${language === div.langCode ? ' selectedLang' : ''}`}
					key={div.langCode}
					onClick={() => setLanguage(div.langCode)}
				>
					{div.langCode.toUpperCase()}
				</motion.div>
			))}
		</motion.div>
	);
}

export default LanguageBanner;